// This file is autogenerated. Any changes will be overwritten.

import useUID from '../../../hooks/useUID';

export const set = 'streamline';

export const name = 'case-solid';

export const Component = () => {
  const maskId = useUID();

  return (
    <>
      <defs>
        <mask id={maskId} fill='#000' stroke='#000' strokeLinecap='square'>
          <path fill='#fff' stroke='#fff' d='M0 0h18v18H0z' />
          <path d='M.563 8.563h6.75m3.375 0h6.75' />
          <path
            stroke='#fff'
            d='M7.313 9.312a1.687 1.687 0 1 0 3.375 0v-.9a1.687 1.687 0 1 0-3.376 0v.9Z'
          />
        </mask>
      </defs>
      <g stroke='currentColor'>
        <path fill='none' d='M12.375 4.063a3.375 3.375 0 0 0-6.75 0' />
        <path
          fill='currentColor'
          d='M16.313 4.063H1.688c-.622 0-1.125.503-1.125 1.125v9c0 .62.503 1.124 1.125 1.124h14.624c.622 0 1.125-.503 1.125-1.124v-9c0-.622-.503-1.125-1.125-1.125Z'
          mask={`url(#${maskId})`}
        />
      </g>
    </>
  );
};

export const viewBox = '0 -1 18 18';
